import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

const OrderPersonalTrainingPopup = ({ onUpdate, userData }) => {
  const navigate = useNavigate()

  const [cantBeClosed, _setCantBeClosed] = useState(
    userData.buildingId === null && userData.trainerId === null,
  )

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.keyCode === 27 && !cantBeClosed) {
        onUpdate('', null)
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [cantBeClosed, onUpdate])

  const handleClick = (e) => {
    e.preventDefault()
    if (!cantBeClosed) onUpdate('', null)
    navigate('/dashboard/store')
  }

  const closePopup = (e) => {
    e.preventDefault()
    if (!cantBeClosed) onUpdate('', null)
  }

  return (
    <div className={'ctp-order-personal-training-popup modal'}>
      <div className={'modal-background'} onClick={closePopup} />
      <div className={'modal-content'}>
        <p>We will contact you shortly. Meanwhile, you can check our services in store.</p>
        <button className={'button button-primary is-block'} onClick={handleClick}>
          Go to Store
        </button>
        {!cantBeClosed && (
          <button className="modal-close is-large" aria-label="close" onClick={closePopup} />
        )}
      </div>
    </div>
  )
}

OrderPersonalTrainingPopup.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    buildingId: PropTypes.string,
    trainerId: PropTypes.string,
  }).isRequired,
}

export default OrderPersonalTrainingPopup
